// working  
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'; 
import nexapi from '../../services/api';
import { RequestModel } from '../../types/models/RequestModel';
import { RequestStatus } from '../slices/commonEnum';

interface ArchiveState {
  data: RequestModel[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
  status: string | null;
  myRequests: number;
  myActionedRequests: number;
  allRequests: number;
  myReviews: number;
}

interface ArchiveResponse {
  applications: RequestModel[];
  totalCount: number;
}

const API_URL = '/RequestForm';
function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, ''); // Removes all HTML tags
}
export const fetchTotalCountArchives = createAsyncThunk<
  { totalCounts: Record<string, number> },
  { year: number; userId: string }
>(
  'requestForm/fetchTotalCountArchives',
  async ({ year, userId }) => {
    try {
      const response = await nexapi.post(`${API_URL}/GetArchivedTotalCount?year=${year}&userId=${userId}`);
      const data = response.data;
      
      return { totalCounts: data?.data || {} };
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);
export const fetchArchives = createAsyncThunk<
  ArchiveResponse,
  { filters: Record<string, any>; page: number; numberOfRecord: number; year: number ; sortColumn: string; sortOrder: 'asc' | 'desc'; companyId: string}
>(
  'requestForm/fetchArchives',
  async ({ filters, page, numberOfRecord, year, sortColumn = '', sortOrder = 'asc' ,companyId}) => {
    try {
      const response = await nexapi.post(
        `${API_URL}/GetYearlyArchived?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&year=${year}&requestId=${filters.requestId}&applicationId=${filters.applicationId}&subTypeId=${filters.subtypeId}&requestor=${filters.requestorId}&statusfilter=${filters.statusfilter}&submittedDateFrom=${filters.submittedDateFrom}&submittedDateTo=${filters.submittedDateTo}&search=${filters.search}&userTimeZone=${filters.userTimeZone}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&companyId=${companyId}`
      );

      const data = response.data;

      if (Array.isArray(data?.data)) {
        const filteredData = data.data.map((item) => {
          // let approverFields: Record<string, string> = {};
          // for (let i = 1; i <= 9; i++) {
          //   approverFields[`_Approver${i}`] = "";
          // }

          // if (Array.isArray(item.approver)) {
          //   item.approver.forEach((approverItem) => {
          //     const seq = approverItem.sequence;
          //     if (seq >= 1 && seq <= 9) {
          //       approverFields[`_Approver${seq}`] = approverItem.approverModel?.givenName || "";
          //     }
          //   });
          // }

          // let referenceFields: Record<string, string> = {};
          // for (let i = 1; i <= 12; i++) {
          //   referenceFields[`_Reference${i}`] = "";
          // }

          // let seq = 1;
          // if (Array.isArray(item.refrence)) {
          //   item.refrence.forEach((refrenceItem) => {
          //     referenceFields[`_Reference${seq}`] = refrenceItem?.value || "";
          //     seq++;
          //   });
          // }

          const approverRemarks = item.historyLogs
            ? item.historyLogs
                .map((log) => {
                  const formattedDate = log.submittedDateTime
                    ? new Date(log.submittedDateTime).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }).replace(",", "")
                    : "";
                  return `${log.userName} (${formattedDate}) - ${log.remarks}`;
                })
                .join("\n")
            : "";
                 
          return {
            Id: item.id,
            RequestId: item.requestID,
            Application: item.applicationTitle,
            Subtype: item.subtypeTitle,
            _Requester: item.requestorName,
            Status:
              item.formActionString.charAt(0).toUpperCase() +
              item.formActionString.slice(1) +
              (item.formActionString.toLowerCase() === "pending" && item?.currentOwnerName?.trim()
                ? " with " + item.currentOwnerName
                : ""),
            _CompanyCode: item.company.companyCode,
            SubmittedDate: item.submittedDateTime
              ? parseUtcDate(item.submittedDateTime).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                 
                }).replace("Sept", "Sep") // Simple replacement
              : "-",
            // _FromDate: item.fromDate
            //   ? new Date(item.fromDate).toLocaleString("en-GB", {
            //       day: "2-digit",
            //       month: "short",
            //       year: "numeric",
            //       hour: "2-digit",
            //       minute: "2-digit",
            //       hour12: true,
            //     }).replace(",", "")
            //   : "",
            // _ToDate: item.toDate
            //   ? new Date(item.toDate).toLocaleString("en-GB", {
            //       day: "2-digit",
            //       month: "short",
            //       year: "numeric",
            //       hour: "2-digit",
            //       minute: "2-digit",
            //       hour12: true,
            //     }).replace(",", "")
            //   : "",
            Subject: item.subject,
            // _Reviewer: item.reviewer,
            // ...approverFields,
            // _Description:  stripHtml(item.description),
            // ...referenceFields,
            // _Reason: item.reason,
            // _RequesterRemark: item.remark,
            // _ApproverRemark: approverRemarks,
          };
        });

        return { applications: filteredData, totalCount: data.totalCount };
      } else {
        console.error("Invalid API Response:", data);
        const headerKeys = {
        Id: "",
        RequestId: "",
        Application: "",
        Subtype:"",
        Status:"",
        SubmittedDate:"",
        Subject: "",
      };

      return {
        dashboard: [headerKeys], // Only headers structure, no data
        totalCount: 0,
      };
        //return { applications: [], totalCount: 0 };
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);

export const fetchMyRequest = createAsyncThunk<
  ArchiveResponse,
  { filters: Record<string, any>; page: number; numberOfRecord: number; year: number; userId: string; sortColumn: string; sortOrder: 'asc' | 'desc'; }
>(
  'requestForm/fetchMyRequest',
  async ({ filters, page, numberOfRecord, year, userId, sortColumn = '', sortOrder = 'asc' }) => {
    try {
      const response = await nexapi.post(
        `${API_URL}/GetYearlyArchivedMyRequest?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&year=${year}&userId=${userId}&requestId=${filters.requestId}&applicationId=${filters.applicationId}&subTypeId=${filters.subtypeId}&requestor=${filters.requestorId}&statusfilter=${filters.statusfilter}&submittedDateFrom=${filters.submittedDateFrom}&submittedDateTo=${filters.submittedDateTo}&search=${filters.search}&userTimeZone=${filters.userTimeZone}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`
      );

      const data = response.data;
       
      if (Array.isArray(data?.data)) {
        const filteredData = data.data.map((item) => {
          let approverFields: Record<string, string> = {};
          for (let i = 1; i <= 9; i++) {
            approverFields[`_Approver${i}`] = "";
          }

          if (Array.isArray(item.approver)) {
            item.approver.forEach((approverItem) => {
              const seq = approverItem.sequence;
              if (seq >= 1 && seq <= 9) {
                approverFields[`_Approver${seq}`] = approverItem.approverModel?.givenName || "";
              }
            });
          }

          let referenceFields: Record<string, string> = {};
          for (let i = 1; i <= 12; i++) {
            referenceFields[`_Reference${i}`] = "";
          }


          var seq = 1;
          if (Array.isArray(item.refrence)) {
            item.refrence.forEach((refrenceItem) => {
             
              referenceFields[`_Reference${seq}`] = refrenceItem?.value || "";
              seq++;
            });
          }
          const approverRemarks = item.historyLogs
            ? item.historyLogs
                .map((log) => {
                  const formattedDate = log.submittedDateTime
                    ? new Date(log.submittedDateTime).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }).replace(",", "")
                    : "";
                  return `${log.userName} (${formattedDate}) - ${log.remarks}`;
                })
                .join("\n")
            : "";

          return {
            Id: item.id,
            RequestId: item.requestID,
            Application: item.applicationTitle,
            Subtype: item.subtypeTitle,
            _Requester: item.requestorName,
            Status: item.formActionString.charAt(0).toUpperCase() +
              item.formActionString.slice(1) +
              (item.formActionString.toLowerCase() === "pending" && item?.currentOwnerName?.trim()
                ? " with " + item.currentOwnerName
                : ""),
            _CompanyCode: item.companyCode,
            SubmittedDate: item.submittedDateTime
              ? parseUtcDate(item.submittedDateTime).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                 
                }).replace("Sept", "Sep") // Simple replacement
              : "-",
            _FromDate: item.fromDate
              ? parseUtcDate(item.fromDate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                 
                }).replace(",", "")
              : "",
            _ToDate: item.toDate
              ? parseUtcDate(item.toDate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                 
                }).replace(",", "")
              : "",
            Subject: item.subject,
            _Reviewer: item.reviewer,
            ...approverFields,
            _Description:  stripHtml(item.description),
            ...referenceFields,
            _Reason: item.reason,
            _RequesterRemark: item.remark,
            _ApproverRemark: approverRemarks,
          };
        });

        return { applications: filteredData, totalCount: data.totalCount };
      } else {
        console.error("Invalid API Response:", data);
        const headerKeys = {
        Id: "",
        RequestId: "",
        Application: "",
        Subtype:"",
        Status:"",
        SubmittedDate:"",
        Subject: "",
      };

      return {
        dashboard: [headerKeys], // Only headers structure, no data
        totalCount: 0,
      };
        //return { applications: [], totalCount: 0 };
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);


export const fetchMyReview = createAsyncThunk<
  ArchiveResponse,
  { filters: Record<string, any>; page: number; numberOfRecord: number; year: number; userId: string; sortColumn: string; sortOrder: 'asc' | 'desc'; }
>(
  'requestForm/fetchMyReview',
  async ({ filters, page, numberOfRecord, year, userId, sortColumn = '', sortOrder = 'asc' }) => {
    try {
      const response = await nexapi.post(
        `${API_URL}/GetYearlyArchivedMyReview?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&year=${year}&userId=${userId}&requestId=${filters.requestId}&applicationId=${filters.applicationId}&subTypeId=${filters.subtypeId}&requestor=${filters.requestorId}&statusfilter=${filters.statusfilter}&submittedDateFrom=${filters.submittedDateFrom}&submittedDateTo=${filters.submittedDateTo}&search=${filters.search}&userTimeZone=${filters.userTimeZone}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`
      );
      const data = response.data;
       
      if (Array.isArray(data?.data)) {
        const filteredData = data.data.map((item) => {
          let approverFields: Record<string, string> = {};
          for (let i = 1; i <= 9; i++) {
            approverFields[`_Approver${i}`] = "";
          }

          if (Array.isArray(item.approver)) {
            item.approver.forEach((approverItem) => {
              const seq = approverItem.sequence;
              if (seq >= 1 && seq <= 9) {
                approverFields[`_Approver${seq}`] = approverItem.approverModel?.givenName || "";
              }
            });
          }

          let referenceFields: Record<string, string> = {};
          for (let i = 1; i <= 12; i++) {
            referenceFields[`_Reference${i}`] = "";
          }

          var seq = 1;
          if (Array.isArray(item.refrence)) {
            item.refrence.forEach((refrenceItem) => {
              referenceFields[`_Reference${seq}`] = refrenceItem?.value || "";
              seq++;
            });
          }

          const approverRemarks = item.historyLogs
            ? item.historyLogs
                .map((log) => {
                  const formattedDate = log.submittedDateTime
                    ? new Date(log.submittedDateTime).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                      }).replace(",", "")
                    : "";
                  return `${log.userName} (${formattedDate}) - ${log.remarks}`;
                })
                .join("\n")
            : "";

          return {
            Id: item.id,
            RequestId: item.requestID,
            Application: item.applicationTitle,
            Subtype: item.subtypeTitle,
            _Requester: item.requestorName,
            Status: item.formActionString.charAt(0).toUpperCase() +
              item.formActionString.slice(1) +
              (item.formActionString.toLowerCase() === "pending" && item?.currentOwnerName?.trim()
                ? " with " + item.currentOwnerName
                : ""),
            _CompanyCode: item.companyCode,
            SubmittedDate:
              item.submittedDateTime
                ? (new Date(item.submittedDateTime)
                    .toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }) || ""
                  ).replace("Sept", "Sep")
                : "-",

           _FromDate: item.fromDate
  ? ((parseUtcDate(item.fromDate)?.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }) || "").replace(",", ""))
  : "",

_ToDate: item.toDate
  ? ((parseUtcDate(item.toDate)?.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }) || "").replace(",", ""))
  : "",

            Subject: item.subject,
            _Reviewer: item.reviewer,
            ...approverFields,
            _Description:  stripHtml(item.description),
            ...referenceFields,
            _Reason: item.reason,
            _RequesterRemark: item.remark,
            _ApproverRemark: approverRemarks,
          };
        });
        
        return { applications: filteredData, totalCount: data.totalCount };
      } else {
        console.error("Invalid API Response:", data);
        const headerKeys = {
        Id: "",
        RequestId: "",
        Application: "",
        Subtype:"",
        Status:"",
        SubmittedDate:"",
        Subject: "",
      };

      return {
        dashboard: [headerKeys], // Only headers structure, no data
        totalCount: 0,
      };
        //return { applications: [], totalCount: 0 };
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);

export const fetchActioned = createAsyncThunk<
  ArchiveResponse,
  { filters: Record<string, any>; page: number; numberOfRecord: number; year: number; userId: string; sortColumn: string; sortOrder: 'asc' | 'desc'; }
>(
  'requestForm/fetchActioned',
  async ({ filters, page, numberOfRecord, year, userId, sortColumn = '', sortOrder = 'asc' }) => {
    try {
      const response = await nexapi.post(
        `${API_URL}/GetYearlyArchivedActioned?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&year=${year}&userId=${userId}&requestId=${filters.requestId}&applicationId=${filters.applicationId}&subTypeId=${filters.subtypeId}&requestor=${filters.requestorId}&statusfilter=${filters.statusfilter}&submittedDateFrom=${filters.submittedDateFrom}&submittedDateTo=${filters.submittedDateTo}&search=${filters.search}&userTimeZone=${filters.userTimeZone}&sortColumn=${sortColumn}&sortOrder=${sortOrder}`
      );
      
      const data = response.data;

      if (Array.isArray(data?.data)) {
        const filteredData = data.data.map((item) => {
          let approverFields: Record<string, string> = {};
          for (let i = 1; i <= 9; i++) {
            approverFields[`_Approver${i}`] = "";
          }

          if (Array.isArray(item.approver)) {
            item.approver.forEach((approverItem) => {
              const seq = approverItem.sequence;
              if (seq >= 1 && seq <= 9) {
                approverFields[`_Approver${seq}`] = approverItem.approverModel?.givenName || "";
              }
            });
          }

          let referenceFields: Record<string, string> = {};
          for (let i = 1; i <= 12; i++) {
            referenceFields[`_Reference${i}`] = "";
          }

          let seq = 1;
          if (Array.isArray(item.refrence)) {
            item.refrence.forEach((refrenceItem) => {
              referenceFields[`_Reference${seq}`] = refrenceItem?.value || "";
              seq++;
            });
          }

          const approverRemarks = item.historyLogs
            ? item.historyLogs
                .map((log) => {
                  const formattedDate = log.submittedDateTime
                    ? new Date(log.submittedDateTime).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                      }).replace(",", "")
                    : "";
                  return `${log.userName} (${formattedDate}) - ${log.remarks}`;
                })
                .join("\n")
            : "";

          return {
            Id: item.id,
            RequestId: item.requestID,
            Application: item.applicationTitle,
            Subtype: item.subtypeTitle,
            _Requester: item.requestorName,
            Status:
              item.formActionString.charAt(0).toUpperCase() +
              item.formActionString.slice(1) +
              (item.formActionString.toLowerCase() === "pending" && item?.currentOwnerName?.trim()
                ? " with " + item.currentOwnerName
                : ""),
            _CompanyCode: item.companyCode,
            SubmittedDate: item.submittedDateTime
              ? parseUtcDate(item.submittedDateTime).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                }).replace("Sept", "Sep") // Simple replacement
              : "-",
            _FromDate: item.fromDate
              ? parseUtcDate(item.fromDate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                }).replace(",", "")
              : "",
            _ToDate: item.toDate
              ? parseUtcDate(item.toDate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
                 
                }).replace(",", "")
              : "",
            Subject: item.subject,
            _Reviewer: item.reviewer,
            ...approverFields,
            _Description:  stripHtml(item.description),
            ...referenceFields,
            _Reason: item.reason,
            _RequesterRemark: item.remark,
            _ApproverRemark: approverRemarks,
          };
        });

        return { applications: filteredData, totalCount: data.totalCount };
      } else {
        console.error("Invalid API Response:", data);
         const headerKeys = {
        Id: "",
        RequestId: "",
        Application: "",
        Subtype:"",
        Status:"",
        SubmittedDate:"",
        Subject: "",
      };

      return {
        dashboard: [headerKeys], // Only headers structure, no data
        totalCount: 0,
      };
        //return { applications: [], totalCount: 0 };
      }
    } catch (error) {
      console.error("API Call Failed:", error);
      throw error;
    }
  }
);

function parseUtcDate(dateString) {
  // If it already ends with Z, treat as UTC
  if (dateString.endsWith("Z")) {
    return new Date(dateString);
  }

  // Otherwise, force treat it as UTC by appending Z
  return new Date(dateString + "Z");
}


const initialState: ArchiveState = {
  data: [],
  totalRecords: 0,
  loading: false,
  error: null,
  status: RequestStatus.Status,
  myRequests: 0,
  myActionedRequests: 0,
  allRequests: 0,
  myReviews: 0,
};

const archiveSlice = createSlice({
  name: 'requestForm',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchives.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArchives.fulfilled, (state, action) => {
        state.data = action.payload.applications;
        state.totalRecords = action.payload.totalCount;
        state.status = RequestStatus.SUCCEEDED;
        state.loading = false;
      })
      .addCase(fetchArchives.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch archives";
      })
      .addCase(fetchMyRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyRequest.fulfilled, (state, action) => {
        state.data = action.payload.applications;
        state.totalRecords = action.payload.totalCount;
        state.status = RequestStatus.SUCCEEDED;
        state.loading = false;
      })
      .addCase(fetchMyRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch my requests";
      })      
      .addCase(fetchMyReview.fulfilled, (state, action) => {
        state.data = action.payload.applications;
        state.totalRecords = action.payload.totalCount;
        state.status = RequestStatus.SUCCEEDED;
        state.loading = false;
      })
      .addCase(fetchMyReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch my reviews";
      })      
      .addCase(fetchActioned.fulfilled, (state, action) => {
        state.data = action.payload.applications;
        state.totalRecords = action.payload.totalCount;
        state.status = RequestStatus.SUCCEEDED;
        state.loading = false;
      })
      .addCase(fetchActioned.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch All Actioned";
      })
      .addCase(fetchTotalCountArchives.pending, (state) => {
              state.loading = true;
              state.error = null;
      })
      .addCase(fetchTotalCountArchives.fulfilled, (state, action) => {
        state.loading = false;
        state.allRequests = action.payload.totalCounts.allRequestCount  || 0; 
        state.myRequests = action.payload.totalCounts.requestCountRec  || 0; 
        state.myActionedRequests = action.payload.totalCounts.actionedCountRec  || 0; 
        state.myReviews = action.payload.totalCounts.reviewCountRec  || 0; 
      })
      .addCase(fetchTotalCountArchives.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default archiveSlice.reducer;
